import React, { useEffect, useMemo, useState } from "react";
import { LineChart, Line, XAxis, YAxis, ResponsiveContainer, Tooltip, Legend, CartesianGrid } from "recharts";
import { PageTitle, Panel, EmptyState } from "../components/ui";
import { useI18n } from "../i18n";
import { CL } from "../api";

export default function Trends() {
  const { t } = useI18n();
  const [acts, setActs] = useState([]);
  useEffect(() => { CL.listActivities().then(setActs).catch(() => {}); }, []);

  const data = useMemo(() => {
    const byYear = {};
    acts.forEach((a) => {
      const y = a.period_year || 2025;
      byYear[y] = byYear[y] || { year: String(y), scope1: 0, scope2: 0, scope3: 0 };
      byYear[y][`scope${a.scope}`] += a.emissions || 0;
    });
    return Object.values(byYear).sort((a, b) => a.year.localeCompare(b.year));
  }, [acts]);

  return (
    <div data-testid="trends-page">
      <PageTitle title={t("trends")} subtitle={t("byScope")} />
      <Panel>
        {data.length === 0 ? <EmptyState text={t("noData")} /> : (
          <div className="h-80">
            <ResponsiveContainer width="100%" height="100%">
              <LineChart data={data}>
                <CartesianGrid strokeDasharray="3 3" stroke="#eef0e8" vertical={false} />
                <XAxis dataKey="year" axisLine={false} tickLine={false} tick={{ fill: "#6b7268", fontSize: 12 }} />
                <YAxis axisLine={false} tickLine={false} tick={{ fill: "#8a8f83", fontSize: 11 }} />
                <Tooltip formatter={(v) => `${Number(v).toLocaleString()} ${t("kgco2e")}`} />
                <Legend />
                <Line type="monotone" dataKey="scope1" name={t("scope1")} stroke="#14512f" strokeWidth={2} dot={{ r: 3 }} />
                <Line type="monotone" dataKey="scope2" name={t("scope2")} stroke="#2f8f5b" strokeWidth={2} dot={{ r: 3 }} />
                <Line type="monotone" dataKey="scope3" name={t("scope3")} stroke="#e08a1e" strokeWidth={2} dot={{ r: 3 }} />
              </LineChart>
            </ResponsiveContainer>
          </div>
        )}
      </Panel>
    </div>
  );
}
